import React, { useState } from 'react';
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

interface DeleteButtonProps {
  onDelete: () => void;
  confirmMessage?: string;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ onDelete, confirmMessage }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirm = () => {
    onDelete();
    setOpen(false);
  };

  return (
    <>
      <IconButton color="error" size="small" onClick={handleClickOpen}>
        <DeleteIcon />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-confirm-dialog"
        fullWidth
        maxWidth="sm"
        className='deleteModalWrap'
      >
        <DialogTitle id="delete-confirm-dialog">Confirm Delete</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {confirmMessage || 'Are you sure you want to delete this item?'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className='cancelBtn' variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleConfirm} className='deleteBtn' color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteButton;
